/**
 * @module app.shared
 */

/**
 * Copy the contents of `element` to the clipboard
 * @param element
 */
export function copyElementContentsToClipboard(element: Element): void {
    // create a range and select the element
    const range = document.createRange();
    range.selectNodeContents(element);

    // get the window selection
    const selection = window.getSelection();
    if(selection) {
        // remove existing ranges from selection
        selection.removeAllRanges();

        // add the new range
        selection.addRange(range);

        // execute Copy
        document.execCommand('copy');

        // remove all ranges
        selection.removeAllRanges();
    }

}
